import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Login from './views/Login.vue'

Vue.use(Router)

export default new Router({
    // mode: 'hash',
    // mode: 'history',
    base: process.env.BASE_URL,
    routes: [{
            path: '/',
            name: 'login',
            component: Login,
            meta: {
                requireAuth: true
            },
        },
        {
            path: '/home',
            name: 'home',
            component: Home,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/about',
            name: 'about',
            meta: {
                requireAuth: true
            },
            component: () =>
                import ( /* webpackChunkName: "about" */ './views/About.vue')
        },
        {
            path: '/print',
            name: 'print',
            meta: {
                requireAuth: true
            },
            component: () =>
                import ( /* webpackChunkName: "about" */ './views/Print.vue')
        },

    ]
})